import React from 'react';
import type { ReactNode } from 'react';
import type { TextDesktop } from '@alfa-bank/site-text-v2/desktop';
import type { TextMobile } from '@alfa-bank/site-text-v2/mobile';

import { getId } from '../../../helpers';

import type { TConfig } from './config';

export const headingRenderer =
    (Text: typeof TextDesktop | typeof TextMobile, config: TConfig) =>
    ({ children }: { children: ReactNode & ReactNode[] }) => {
        const [text] = children;
        const id = getId(text?.toString());
        const { marginBottom, marginTop, view } = config;

        return (
            <div id={id}>
                <Text styler={{ marginTop, marginBottom }} tag={'h2'} view={view}>
                    {children}
                </Text>
            </div>
        );
    };
